// extracted by mini-css-extract-plugin
module.exports = {"padding-label":"src-_components-___EmailForm-module__padding-label___YlsyX"};